module.exports = __webpack_public_path__ + "media/images/operation_jobs/door_close_sharp_washer-d85b23eb9c122f589808eff9cd716966.gif";